import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function Settings() {
  const { logout } = useAuth();
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    void api.listSavedSearches().then((s) => setCount(s.length));
  }, []);

  return (
    <div className="max-w-xl mx-auto px-4 py-6 space-y-4 font-mono text-sm">
      <h1 className="text-xl">Settings</h1>
      <dl className="grid grid-cols-2 gap-2 text-zinc-300">
        <dt className="text-zinc-500">saved searches</dt><dd>{count ?? "…"}</dd>
        <dt className="text-zinc-500">env</dt><dd>configured via container env vars</dd>
      </dl>
      <button
        onClick={() => void logout()}
        className="bg-zinc-800 hover:bg-zinc-700 px-3 py-1 rounded"
      >
        Sign out
      </button>
    </div>
  );
}
